import { render, staticRenderFns } from "./perfstats.vue?vue&type=template&id=0c6bcaec&scoped=true&"
import script from "./perfstats.vue?vue&type=script&lang=js&"
export * from "./perfstats.vue?vue&type=script&lang=js&"
import style0 from "./perfstats.vue?vue&type=style&index=0&id=0c6bcaec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6bcaec",
  null
  
)

export default component.exports